// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function EmptyContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                (
                    (rowContractData.inputMissingRollup === 0 && rowContractData.inputMissingCount === 0)
                    // && (rowContractData.contractLevel === 'Guild' ||
                    //     rowContractData.contractLevel === 'Option' ||
                    //     rowContractData.contractLevel === 'Cast' ||
                    //     rowContractData.contractLevel === 'Engagement'
                        && ( rowContractData.contractLevel !== 'Guild'
                        && rowContractData.contractLevel !== 'Option'
                        &&  rowContractData.contractLevel !== 'Cast'
                        &&  rowContractData.contractLevel !== 'Engagement'
                        &&  rowContractData.contractLevel !== 'Property'
                        &&  rowContractData.contractLevel !== 'Contract Type'
                        &&  rowContractData.contractLevel !== 'Labor Group'
                        &&  rowContractData.contractLevel !== 'Deal Type'
                        &&  rowContractData.contractLevel !== 'Deal'
                        &&  rowContractData.contractLevel !== 'Participant Deal'

                        &&  rowContractData.contractLevel !== 'Series'
                        &&  rowContractData.contractLevel !== 'Season'
                        // ||

                        // (
                        //     rowContractData.contractLevel === 'Participant' ||
                        //     rowContractData.contractLevel === 'Participant Deal' ||
                        //     rowContractData.contractLevel === 'Participant_Deal')
                        )
                    && (rowContractData.comboStatus !== 'a')
                )
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="EmptyContractAvatar"
                    >
                        <Avatar sx={{height: 20, width: 20, fontSize: 14, opacity: .1}}> </Avatar>
                    </Tooltip>
                    </div>}
        </Box>

    )

}
